/**
 * Feature Flags for Production-Safe Rollouts
 * 
 * Control new features via environment variables for instant rollback capability
 */

export const FEATURE_FLAGS = {
  // Order Amendment Flow - Default false for production safety
  ENABLE_ORDER_AMENDMENT_FLOW: process.env.REACT_APP_ENABLE_AMENDMENT_FLOW === 'true',
  
  // Store Bypass - Auto-redirect to Aquila (Store 1) and skip store selection
  ENABLE_STORE_BYPASS: process.env.REACT_APP_ENABLE_STORE_BYPASS === 'true',
  
  // Future feature flags can be added here
  // ENABLE_NEW_PAYMENT_FLOW: process.env.REACT_APP_ENABLE_NEW_PAYMENT === 'true',
};

// Helper function for conditional feature enablement
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] || false;
};

// Debug helper - shows all feature flag states (dev only)
export const getFeatureFlagStatus = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('🚩 Feature Flags Status:', FEATURE_FLAGS);
  }
  return FEATURE_FLAGS;
};